module.exports = __webpack_public_path__ + "static/media/square.faa2cdfc.svg";